import { render, staticRenderFns } from "./CenterInfo.vue?vue&type=template&id=37060e1e&scoped=true"
import script from "./CenterInfo.vue?vue&type=script&lang=ts"
export * from "./CenterInfo.vue?vue&type=script&lang=ts"
import style0 from "./CenterInfo.vue?vue&type=style&index=0&id=37060e1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37060e1e",
  null
  
)

export default component.exports